import { PayloadAction } from '@reduxjs/toolkit';
import { ChatTab, PrivateChatActiveViewState, ChatMessagePayload } from 'features/chat/types';
import { call, put, select } from 'redux-saga/effects';
import {
  messageSent,
  selectActiveChatTab,
  selectChatPanelOpen,
  selectOptimisticImageBlobs,
  selectPrivateChatActiveView,
} from 'features/chat/chatSlice';
import { decryptE2eeMessageSaga } from 'features/chat/sagas/decryptE2eeMessageSaga';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { revokeBlobUrls } from 'features/chat/utils/revokeBlobUrls';
import { eventBus } from 'utils/eventBus';

export function* onChatMessageSentSaga(action: PayloadAction<ChatMessagePayload>) {
  let { payload } = action;

  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  if (e2eeEnabled) {
    payload = yield call(decryptE2eeMessageSaga, action.payload);
  }

  if (payload) {
    const blobsToRevoke: string[] | undefined = yield select(
      selectOptimisticImageBlobs,
      payload.id
    );
    yield put(messageSent(payload));
    // Only revoke the preview blobs once the message carries the delivered
    // images; without them the optimistic previews are still being rendered.
    if (payload.images?.length && blobsToRevoke) {
      yield call(revokeBlobUrls, blobsToRevoke);
    }

    const panelOpen: boolean = yield select(selectChatPanelOpen);
    const activeTab: ChatTab = yield select(selectActiveChatTab);
    const privateChatActiveView: PrivateChatActiveViewState = yield select(
      selectPrivateChatActiveView
    );

    const message = {
      message: payload,
      chatState: {
        panelOpen,
        activeTab: activeTab === 0 ? 'public' : 'private',
        privateChatActiveView,
      },
    };

    yield call(eventBus.sendMessage, 'chatMessageReceived', {}, message);
  }
}
